import { useIntl } from 'react-intl'
import type { PatternFormatProps } from 'react-number-format'
import { PatternFormat } from 'react-number-format'

import type { TextFieldBehaviorProps } from '../FormElements/TextFieldBehavior'
import { TextFieldBehavior } from '../FormElements/TextFieldBehavior'

import messages from '@components/forms/messages'

export type DateInputProps = Omit<
  PatternFormatProps<TextFieldBehaviorProps>,
  | 'value'
  | 'placeholder'
  | 'type'
  | 'onChange'
  | 'format'
  | 'mask'
  | 'onValueChange'
  | 'customInput'
  | 'autoComplete'
  | 'placeholder'
  | 'allowEmptyFormatting'
> & {
  onChange: (value: string) => void
  name: Required<PatternFormatProps<TextFieldBehaviorProps>['name']>
  value: Required<PatternFormatProps<TextFieldBehaviorProps>['value']>
}

export function DateInput({ value, onChange, ...rest }: DateInputProps) {
  const { formatMessage } = useIntl()

  return (
    <PatternFormat
      {...rest}
      autoComplete="off"
      customInput={TextFieldBehavior}
      format="####-##-##"
      mask="_"
      placeholder={formatMessage(messages.dateFieldPlaceholder)}
      type="tel"
      value={value ?? ''}
      onValueChange={({ formattedValue }) => {
        onChange(formattedValue)
      }}
    />
  )
}
